<!-- <ng-container *ngIf="menu$ | async as menu; else loadingTemplate"> -->

<ng-container *ngIf="menu$$; else loadingTemplate">

  <ng-container *ngFor="let link of menu$$">

    <ng-container *ngIf="link.children;else simpleLink">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-icon
              *ngIf="link.icon"
              class="menu-icon">
              {{link.icon}}
            </mat-icon>
            {{link.label}}
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a
              mat-list-item
              *ngFor="let item of link.children"
              class="menu-list-item"
              [routerLink]="['/'+item.route]"
              [routerLinkActiveOptions]="{exact:true}"
              routerLinkActive="router-link-active">
              {{ item.label }}
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <ng-template #simpleLink>
      <mat-nav-list>
        <a
          mat-list-item
          class="menu-list-item"
          [routerLink]="['/'+link.route]"
          [routerLinkActiveOptions]="{exact:true}"
          routerLinkActive="router-link-active">
          <mat-icon
            *ngIf="link.icon"
            class="menu-icon">
            {{link.icon}}
          </mat-icon>
          {{ link.label }}
        </a>
      </mat-nav-list>
    </ng-template>

  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loader-spinner-container m-t-25">
    <mat-spinner
      color="primary"
      [diameter]="50"></mat-spinner>
  </div>
</ng-template>
